import axios from "axios";

export const evaluate_model=async()=>{
    return await axios.get(`https://health.neuronai.life/evaluate_model`);
}